import { jsx as _jsx } from "react/jsx-runtime";
import { createStylesContext, Flex, useMultiStyleConfig, } from '@chakra-ui/react';
import { ToolbarProvider } from './ToolbarContext';
const [ToolbarStylesProvider, useToolbarStyles] = createStylesContext('Toolbar');
export { useToolbarStyles };
/**
 * Container for the toolbar.
 */
export const Toolbar = ({ children, ...props }) => {
    const styles = useMultiStyleConfig('Toolbar', props);
    return (_jsx(ToolbarProvider, { ...props, children: _jsx(ToolbarStylesProvider, { value: styles, children: _jsx(Flex, { __css: styles.container, ...props, children: children }) }) }));
};
